export { default } from './BootstrapComponent';
